export default "<!-- <router-outlet name=\"main\"></router-outlet> -->\n<router-outlet></router-outlet>"